module.exports = __webpack_public_path__ + "img/Pista_3618.87a964b7.png";